import {
  ActivityResponse,
  EmployeeTypeResponse,
  ProjectResponse
} from 'generated/index';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { queries } from 'RestAPIs/rapini';

import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import { FieldKey } from '../input-field-grants';
import ControlledFavoriteAutocomplete from 'components/shared/ControlledFields/ControlledFavoriteAutocomplete';
import { ControlledAutoComplete } from 'components/shared/ControlledFields';

type Props = {
  enable?: boolean;
  control: Control<any>;
  activities?: ActivityResponse[];
  employeeType?: EmployeeTypeResponse | null;
  employeeTypes?: EmployeeTypeResponse[];
  hasFieldGrant: (key: FieldKey) => boolean;
  handleProjectSelect: (project: ProjectResponse | undefined | null) => void;
};

const WhatSection = ({
  enable,
  control,
  activities,
  employeeTypes,
  handleProjectSelect,
  hasFieldGrant
}: Props) => {
  if (!enable) return null;

  const { t } = useTranslation();

  return (
    <MultiStepForm.Section
      title="Wat"
      isEditable={hasFieldGrant('WHAT_IS_EDITABLE')}
      validateFields={['activity', 'projectEntityId']}
    >
      {hasFieldGrant('PROJECT_SELECT') && (
        <ProjectSelect control={control} handleSelect={handleProjectSelect} />
      )}

      <ControlledFavoriteAutocomplete
        name="activity"
        control={control}
        label={t('activity')}
        variant="outlined"
        options={activities ?? []}
        type="ACTIVITY"
        idProperty={'entityId'}
        fullWidth
        disabled={!hasFieldGrant('ACTIVITY_SELECT')}
      />
      {hasFieldGrant('EMPLOYEE_TYPE_SELECT') && (
        <ControlledAutoComplete
          name="employeeType"
          control={control}
          label={t('activityPlanning.expertise')}
          variant="outlined"
          options={(employeeTypes || []).filter(({ name }) => name)}
          idProperty={'entityId'}
          fullWidth
        />
      )}
    </MultiStepForm.Section>
  );
};

const ProjectSelect = ({
  control,
  handleSelect
}: {
  control: Control<any>;
  handleSelect?: (project: ProjectResponse | undefined) => void;
}) => {
  const { t } = useTranslation();
  const { data: projects } = queries.useGetProjects();

  return (
    <ControlledFavoriteAutocomplete
      type={'PROJECT'}
      name="project"
      control={control}
      label={t('activityPlanning.project')}
      variant="outlined"
      options={projects ?? []}
      sortByProp={'name'}
      fullWidth
      idProperty={'entityId'}
      onChange={handleSelect}
    />
  );
};

export default WhatSection;
